import { QueryKey } from '../../enums/QueryKey';
import { getScenarioDriverRows } from '../../services/budgetScenarioDriverRows';
import { createScenarioQuery } from './budgetScenarios';

export const useScenarioDriverRows = createScenarioQuery(QueryKey.BudgetScenarioDriverRows, getScenarioDriverRows);
